import {
  Box,
  Button,
  IconButton,
  DialogActions,
  Modal,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import HiddenModelIcon from "../../IconComp/hiddenModelIcon";
import { useAppDispatch } from "../../../app/hooks";
import { useState } from "react";
import AppErrorMessage from "../../common/AppErrorMessage";
import { hide_medicine } from "../../../features/outOfStockMed/outOfStockMedSlice";
import { getNonMedicalData } from "../../../features/nonMedical/nonMedicalSlice";

interface HideNonMedicineModelProps {
  open: boolean;
  onClose: () => void;
  setOpenSnackbar: any;
  selectedMedicineId: any;
  apiError: any;
  setApiError: any;
  setTotalCount?: any;
  setOutOfStockCount?: any;
  setLowInStockCount?: any;
  page?: any;
  rowsPerPage?: any;
}

export const HideNonMedicineModel = ({
  open,
  onClose,
  setOpenSnackbar,
  selectedMedicineId,
  setApiError,
  apiError,
  setTotalCount,
  setOutOfStockCount,
  setLowInStockCount,
  page,
  rowsPerPage,
}: HideNonMedicineModelProps) => {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  const pharmacyId = localStorage?.getItem("pharmacyId");

  const fetchNonMedicalData = async () => {
    const dto: any = {
      page: page + 1, // API pages are 1-indexed
      limit: rowsPerPage,
    };
    try {
      const res = await dispatch(
        getNonMedicalData({ pharmacy_id: pharmacyId, dto })
      );

      setTotalCount(res?.payload?.pagination?.totalItems || 0);
      setOutOfStockCount(res?.payload?.count?.outOfStockCount || 0);
      setLowInStockCount(res?.payload?.count?.lowStockCount || 0);
    } catch (error) {
      console.error("Error fetching medicine data:", error);
    }
  };

  const handleSubmit = async () => {
    setApiError(false);
    setLoading(true); // start the loader

    const dto = {
      medicine_id: selectedMedicineId?.medicine_id ?? selectedMedicineId,
      pharmacy_id: pharmacyId,
      status: true,
    };

    try {
      const res = await hide_medicine(dto);
      if (res?.success === true) {
        fetchNonMedicalData();
        setApiError(false);
        setOpenSnackbar(true);
        onClose();
      } else {
        setApiError(res?.message || "Failed to hide Non medical product");
      }
    } catch (error: any) {
      setApiError(error?.message || "An unexpected error occurred");
      console.error("Error hiding Non medical product: ", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          width: {
            xs: "310px", // for screens <600px
            sm: "544px", // for screens ≥600px
          },
          bgcolor: "background.paper",
          borderRadius: "12px",
          boxShadow: 24,
          p: 0,
          outline: "none",
          mx: "auto",
          mt: "40vh",
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            px: 1,
            justifyContent: "space-between",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              p: 2,
            }}
          >
            <Box>
              <HiddenModelIcon />
            </Box>
            <Box sx={{ display: "flex", flexDirection: "column", gap: "3px" }}>
              <Box sx={{ fontSize: "18px", fontWeight: 600 }}>
                Hide Medicine
              </Box>
              <Box sx={{ fontSize: "14px", fontWeight: 400, color: "#535862" }}>
                Are you sure you want to Hide this Medicine?
              </Box>
            </Box>
          </Box>

          <Box sx={{ mt: "-30px" }}>
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Box>
        </Box>

        {/* Footer */}
        <DialogActions
          sx={{ mt: "10px", justifyContent: "flex-end", padding: 2 }}
        >
          <Button
            variant="outlined"
            onClick={onClose}
            sx={{
              textTransform: "none",
              fontWeight: 600,
              fontSize: "16px",
              borderRadius: "8px",
              px: 3,
              color: "#414651",
              borderColor: "#BDBDBD",
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleSubmit}
            sx={{
              ml: 2,
              textTransform: "none",
              fontWeight: 600,
              fontSize: "16px",
              borderRadius: "8px",
              px: 3,
              backgroundColor: "#D92D20",
              "&:hover": {
                backgroundColor: "#d64545",
              },
            }}
            disabled={loading} // Disable button when loading
          >
            {loading ? <CircularProgress size={24} color="inherit" /> : "Hide"}
          </Button>
        </DialogActions>
        {apiError && (
          <Box sx={{ p: 2, px: 2 }}>
            <AppErrorMessage message={apiError} />
          </Box>
        )}
      </Box>
    </Modal>
  );
};
